/**
 * Reset scroll position for platform navigation (window + nested session scroll surfaces).
 * Call on every route pathname/key change so deep links never inherit prior page scroll.
 */
export function scrollSurfacesToTop() {
  if (typeof window === "undefined") return;

  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  const shell = document.querySelector("[data-testid='platform-app-shell']");
  if (shell) {
    shell.querySelectorAll(".reg-scroll, [data-route-page], [data-route-stage]").forEach((el) => {
      if (el instanceof HTMLElement) {
        el.scrollTop = 0;
      }
    });
  } else {
    document.querySelectorAll(".reg-scroll").forEach((el) => {
      if (el instanceof HTMLElement) {
        el.scrollTop = 0;
      }
    });
  }
}
